// **********************************************************
// Latest News
// **********************************************************

const latestNewsSlider = document.querySelectorAll('[data-slider="latest-news"]');

const latestNewsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

latestNewsSlider.forEach((el) => new Swiper(el, latestNewsSliderOptions));
